import Table, { TableRow, TableRowCell } from 'core-system/Table'
import moment from 'moment'
import React from 'react'
import { PreTaxBenefitHistoryEntry } from 'redux/employeePlatform/employeePlatformTypes'
import styled from 'styled-components'
import Text from 'core-system/Text'
import FormattingUtils from 'shared/FormattingUtils'
import { useSelector } from 'react-redux'
import { AppState } from 'redux/config/store'
import palette from 'core-system/Themes/palette'

const TABLE_COLUMN_WIDTHS = ['40%', '25%', '25%']

const EmptyTableRow = styled(TableRow)`
  text-align: center;
`

const MobileTableHeader = styled.div`
  display: grid;
  grid-template-columns: ${TABLE_COLUMN_WIDTHS.join(' ')};
  padding-left: 1rem;
`

const renderAllocationHistoryRows = (
  allocationHistory: PreTaxBenefitHistoryEntry[],
  isMobile: boolean,
  irsTaxLimit: number
) => {
  return allocationHistory.map((entry) => {
    return (
      <TableRow>
        <TableRowCell width={TABLE_COLUMN_WIDTHS[0]}>
          <Text variant='action4' hideOverflow>
            {moment(entry.date).format(`${isMobile ? 'MMM' : 'MMMM'} YYYY`)}
          </Text>
        </TableRowCell>
        <TableRowCell width={TABLE_COLUMN_WIDTHS[1]}>
          {isMobile ? (
            <Text variant='action4' hideOverflow>
              {FormattingUtils.formatDollar(entry.employeeTransitDeduction, 0)}
            </Text>
          ) : (
            <Text variant='action4' hideOverflow>
              {`${FormattingUtils.formatDollar(
                entry.employeeTransitDeduction,
                0
              )} / ${FormattingUtils.formatDollar(
                irsTaxLimit - entry.employerTransitContribution,
                0
              )}`}
            </Text>
          )}
        </TableRowCell>
        <TableRowCell width={TABLE_COLUMN_WIDTHS[2]}>
          {isMobile ? (
            <Text variant='action4' hideOverflow>
              {FormattingUtils.formatDollar(entry.employeeParkingDeduction, 0)}
            </Text>
          ) : (
            <Text variant='action4' hideOverflow>
              {`${FormattingUtils.formatDollar(
                entry.employeeParkingDeduction,
                0
              )} / ${FormattingUtils.formatDollar(
                irsTaxLimit - entry.employerParkingContribution,
                0
              )}`}
            </Text>
          )}
        </TableRowCell>
      </TableRow>
    )
  })
}

interface AllocationHistoryTableProps {
  isMobile: boolean
}

const AllocationHistoryTable = React.memo(
  (props: AllocationHistoryTableProps) => {
    const { isMobile } = props

    const { preTaxBenefitHistory } = useSelector(
      (state: AppState) => state.employeePlatform
    )

    const { irsTaxLimit } = useSelector(
      (state: AppState) => state.application.properties
    )

    return (
      <>
        {isMobile ? (
          <MobileTableHeader>
            <Text variant='action3' textColor={palette.text.secondary}>
              Month
            </Text>
            <Text variant='action3' textColor={palette.text.secondary}>
              Transit
            </Text>
            <Text
              variant='action3'
              textColor={palette.text.secondary}
              paddingLeft='1rem'
            >
              Parking
            </Text>
          </MobileTableHeader>
        ) : null}
        <Table
          maxRows={10}
          emptyMessage='No Allocation History'
          headerCells={[
            <TableRowCell width={TABLE_COLUMN_WIDTHS[0]}>Month</TableRowCell>,
            <TableRowCell width={TABLE_COLUMN_WIDTHS[1]}>Transit</TableRowCell>,
            <TableRowCell width={TABLE_COLUMN_WIDTHS[2]}>Parking</TableRowCell>,
          ]}
          rows={
            preTaxBenefitHistory
              ? renderAllocationHistoryRows(
                  preTaxBenefitHistory,
                  isMobile,
                  irsTaxLimit
                )
              : null
          }
        />
      </>
    )
  }
)

if (process.env.NODE_ENV !== 'production') {
  AllocationHistoryTable.displayName = 'AllocationHistoryTable'
}

export default AllocationHistoryTable
